import React from "react";

// reactstrap components


class GeneralHeader extends React.Component {
  

  render() {
    return (
      <>
        <div
          className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style={{
            minHeight: "80px",
            backgroundImage:
              "url(" + require("assets/img/brand/banner01.png") + ")",
            backgroundSize: "cover",
            backgroundPosition: "center top"
          }}
        >
          
          <span className="mask bg-gradient-default opacity-8" />
        </div>
      </>
    );
  }
}
export default GeneralHeader;
